module.exports = fox._r("images/bg/btn_blue.gif", __webpack_public_path__ + "images/bg/btn_blue.gif");


//////////////////
// WEBPACK FOOTER
// ./images/bg/btn_blue.gif
// module id = 1006
// module chunks = 4